import type { IconGlyph } from '../icon';

/**
 * Tractie `user-thick` glyph (medium, 24×24), shown on a selected item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/user-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconUserThick: IconGlyph = {
  name: 'user-thick',
  path: 'M12 12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4S8 3.79 8 6v2c0 2.21 1.79 4 4 4m-2-6c0-1.1.9-2 2-2s2 .9 2 2v2c0 1.1-.9 2-2 2s-2-.9-2-2zm9.72 8.87c-.88-1.09-2.21-1.87-3.95-1.87-.55 0-1 .45-1 1s.45 1 1 1c1.08 0 1.86.47 2.4 1.13.55.69.84 1.59.84 2.37V20H5v-1.5c0-.79.28-1.69.84-2.37.53-.66 1.32-1.13 2.4-1.13.55 0 1-.45 1-1s-.45-1-1-1c-1.74 0-3.08.78-3.95 1.87a5.87 5.87 0 0 0-1.28 3.63V22h18v-3.5c0-1.21-.42-2.56-1.28-3.63Z',
};
